import React from 'react'
import LoopSliderBox from './LoopSliderBox'

function LoopSliderBoxNew(props) {
    return <LoopSliderBox {...props} />
}

export default LoopSliderBoxNew
